@if (mobileEvent){
<div class="drawer-body">

    <h3 class="text-accent-700">
        <strong>Vehiculo {{ mobileEvent?.mobile.name || 'No definido' }}</strong>
    </h3>

    <div class="flex align-item-center ">
        @if (choice) {
            <div class="flex-shrink-0 m-r-10">
                <div class="icon-bg-card" [style.background-color]="choice.color || 'var(--accent-500)'">
                    <i class="icon-card" [class]="choice.icon" [style.color]="'var(--accent-100)'">

                    </i>
                </div>
            </div>
        }

        <div class="flex-grow-1 p-2">

            <div class="f-w-500">
                <span class="text-accent-700"> {{ choice?.label?.['es'] || choice?.label?.['default'] || 'No definido' }}</span><br/>

                @if (mobileEvent?.geofence) {
                    <span class="badge">{{ mobileEvent?.geofence?.name }}</span>
                }

                <div>
                    @if (!(mobileEvent)?.sensors?.ignition) {
                        <span class="text-accent-500 ">
                          <i class="fa-solid fa-power-off"></i>
                          Motor Apagado
                        </span>
                    } @else {
                        <span class="text-success-500 ">
                          <i class="fa-solid fa-power-off"></i>
                          Motor Encendido
                        </span>
                    }
                    <div>

                        @if ((mobileEvent)?.position?.speed > 2) {
                            <div class="text-primary-500 ">
                                <i class="fa-solid fa-gauge-simple-high"></i>
                                En movimiento a {{ ((mobileEvent)?.position?.speed)  | renderSpeed }}
                            </div>
                        } @else {
                            <div class=" text-warn-500 ">
                                <i class="fa-solid fa-gauge-simple"></i>
                                Estacionado
                            </div>
                        }
                        <div>
                            <i class="fa-solid fa-link"></i>
                            Fecha de reporte: {{ mobileEvent.deviceTime | toDateTimeFormat }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


        <br/>
            <br/>

            <app-card [showHeader]="false" padding="10" cardClass="social-widget-card m-b-15 bg-accent-700">
                <div>
                    <strong>Dirección</strong>
                </div>
                <p class="text-wrap p-r-10">{{ (mobileEvent)?.address }}</p>
                <i class="fi fi-rr-direction-signal"></i>
            </app-card>


            <app-card [cardTitle]="'Sensores'" padding="10">
                @for (attr of sensors; track attr) {
                    <app-card class="list-group-item my-task" [showHeader]="false" padding="5">
                        <div class="flex align-item-center">
                            <div class="flex-grow-1 m-l-10">
                                <span class="f-w-600">{{ attr.key }} </span><span
                                    class="task-time ">{{ attr.type }}</span>
                                <p class="m-b-5">
                                </p>

                                <div class="d-flex justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <code>{{ attr.value }}</code>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </app-card>
                }
            </app-card>

        </div>
}




